<template>
  <span class="pw-tooltip" :class="`pw-tooltip--${type} pw-tooltip--${align}`">
    <span class="pw-tooltip__slot">
      <slot><i class="mdi" :class="icon"></i></slot>
    </span>
    <span class="pw-tooltip__text">
      <p v-html="text"></p>
    </span>
  </span>
</template>

<script>
export default {
  name: 'Tip',
  props: {
    text: String,
    type: {
      type: String,
      default: 'info',
    },
    align: {
      type: String,
      default: 'right',
    },
  },
  computed: {
    icon() {
      switch (this.type) {
        case 'info':
          return 'mdi-information';
        case 'warning':
          return 'mdi-alert-outline';
        case 'danger':
          return 'mdi-alert-circle-outline';

        default:
          return 'mdi-check-circle-outline';
      }
    },
  },
};
</script>

<style lang="scss">
.pw-tooltip {
  position: relative;
  display: inline-block;

  &--info {
    i {
      color: #416ed8;
    }
  }
  &--danger {
    i {
      color: #333;
    }
  }
  &--warning {
    background-color: #ffc848;
  }
}

.pw-tooltip .pw-tooltip__text {
  width: 200px;
  margin-left: 16px;
  padding: 8px;
  background-color: #edf1f3;
  color: #333333;
  font-size: 12px;
  opacity: 0;
  transition: all 0.3s ease-in-out;

  /* Position the tooltip */
  position: absolute;
  z-index: -1;
  top: 50%;
  transform: translateY(-50%);
  white-space: normal;
  p {
    margin: 0;
    line-height: 16px;
  }
}
.pw-tooltip--bottom-right {
  .pw-tooltip__text {
    transform: translateY(30%);
    right: 0;
    top: 15px;

    &::after {
      top: 0 !important;
      right: 10px !important;
    }
  }
}

.pw-tooltip .pw-tooltip__text::after {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 100%;
  border-width: 8px;
  border-style: solid;
  border-color: transparent #edf1f3 transparent transparent;
}

.pw-tooltip {
  &__slot {
    &:hover {
      cursor: pointer;
      & + .pw-tooltip__text {
        opacity: 1;
        z-index: 100001;
        word-break: break-word;
      }
    }
  }
}
</style>
